var map = {
	"./australia.json": 1952,
	"./austria.json": 13589,
	"./belgium.json": 2215,
	"./canada.json": 62728,
	"./czech.json": 9673,
	"./denmark.json": 29192,
	"./finland.json": 40870,
	"./france.json": 85733,
	"./germany.json": 49431,
	"./ireland.json": 43249,
	"./israel.json": 12966,
	"./italy.json": 96497,
	"./netherlands.json": 7942,
	"./newzealand.json": 24553,
	"./norway.json": 58868,
	"./poland.json": 46174,
	"./slovakia.json": 98494,
	"./spain.json": 24283,
	"./sweden.json": 43362,
	"./switzerland.json": 13503,
	"./uk.json": 79674,
	"./usa.json": 23705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35049;